const localConfig = {
  REACT_APP_AZURE_CLIENT_ID: '72d4ef34-37bb-4a4e-bcb9-9e4759cb74b4', //"b9f193eb-0b17-49bf-ad62-97d9da8277e6", //"eead2014-32eb-4cb6-acd1-77b234ff3630",
  REACT_APP_API_URL: 'http://localhost:7071',
  // REACT_APP_API_URL: 'https://func-mg-dev1-t1-esgtbaapi-01.azurewebsites.net',
  REACT_APP_AZURE_REDIRECT_URL: 'http://localhost:3000',
  REACT_APP_AZURE_AUTHORITY:
    'https://login.microsoftonline.com/aa42167d-6f8d-45ce-b655-d245ef97da66',
  REACT_APP_AZURE_SCOPE:
    'https://savingsandinvestments.onmicrosoft.com/sp-mg-dev1-t1-esgtba-01/user_impersonation',
  REACT_APP_AUDIENCE: 'https://savingsandinvestments.onmicrosoft.com/sp-mg-dev1-t1-esgtba-01',
  REACT_APP_TENANT_ID: 'aa42167d-6f8d-45ce-b655-d245ef97da66',
  REACT_APP_NAME: 'ESG TBA',
  TARGET_ORIGIN: 'https://centrali.dev1.mandg.com'
}

export const getConfig = () => {
  if (process.env.NODE_ENV === 'development') {
    return localConfig
  } else {
    return window.config
  }
}
